//#region IMPORT
import React from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
/** Icons Import */

import { PropTypes } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { setSearchText, setCoCd } from '../../../../Reducer/SearchReducer';
import NOT_BASIC_02F from './../NOT_BASIC_02/NOT_BASIC_02F';
import NOT_BASIC_01F from './../NOT_BASIC_01/NOT_BASIC_01F';
import { AuthButton } from '../../../../Components/MUIs';
//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index } = props;
  return (
    <React.Fragment>
      {value === index && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: 0, // ✅ flex container 하에서 overflow 계산 가능하게 함
          }}
        >
          {children}
        </Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function NOT_BASIC(props) {
  //#region 변수
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);
  // const gridRef7 = useRef(); // 안전보건총괄책임자(도급)

  //#endregion
  //#region 웹

  //#endregion
  //#region 함수

  //#endregion
  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="NoticeBoard"
          searchYn="Y"
          printYn="N"
          // addYn="Y"
          saveYn={props.value === 0 ? 'N' : 'Y'} // ✅ 공지사항 탭일 때는 저장 버튼 숨김
          // deleteYn="Y"
          // fileYn={props.value === 0 ? 'N' : 'Y'} // 2025-07-22 미리보기 이슈로 잠시 주석 (N처리)
          // fileYn='N'
          searchClick={(e) => {
            dispatch(setSearchText(e));
            if (props.value === 0) {
              props.setFilterClick1(true);
            } else if (props.value === 1) {
              props.setFilterClick2(true);
            } else if (props.value === 2) {
              props.setFilterClick3(true);
            }
          }}
          saveClick={() => {
            if (props.value === 0) {
              props.setSaveClick1(true);
            } else if (props.value === 1) {
              props.setSaveClick2(true);
            } else if (props.value === 2) {
              props.setSaveClick3(true);
            }
          }}
          printClick={() => {
            if (props.value === 0) {
              props.setPrintClick1(true);
            } else if (props.value === 1) {
              props.setPrintClick2(true);
            } else if (props.value === 2) {
              props.setPrintClick3(true);
            } else if (props.value === 3) {
              props.setPrintClick4(true);
            }
          }}
          conditions={[
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: searchInfo.coList || [],
                    value: searchInfo.coCd,
                    onChange: (e) => {
                      dispatch(setCoCd(e));
                      props.handleCoChange(e);

                      if (props.value === 0) {
                        props.setSearchClick1(true);
                      } else if (props.value === 1) {
                        props.setSearchClick2(true);
                      }
                    },
                  },
                ]
              : []),
          ]}
          grids={
            <React.Fragment>
              <Box>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="공지사항"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="게시판"
                    {...A11yProps(1)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  {/* <Tab
                    label="추진결과"
                    {...A11yProps(2)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  /> */}
                </Tabs>
              </Box>
              <CustomTabPanel value={props.value} index={0}>
                <NOT_BASIC_01F
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  copyClick1={props.copyClick1}
                  setCopyClick1={props.setCopyClick1}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <NOT_BASIC_02F
                  filterClick2={props.filterClick2}
                  setFilterClick2={props.setFilterClick2}
                  searchClick2={props.searchClick2}
                  setSearchClick2={props.setSearchClick2}
                  addClick2={props.addClick2}
                  setAddClick2={props.setAddClick2}
                  saveClick2={props.saveClick2}
                  setSaveClick2={props.setSaveClick2}
                  deleteClick2={props.deleteClick2}
                  setDeleteClick2={props.setDeleteClick2}
                  printClick2={props.printClick2}
                  setPrintClick2={props.setPrintClick2}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={3}></CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default NOT_BASIC;
